export default "__VITE_ASSET__tNcb6HqY__"